export enum DealerProductsType {
    Mobiles = 1,
    Gadgets = 2,
    ServiceOffer = 3,
    Refurbish = 4
}
export enum DealerProductsTypeInfo {
    MOBILES = "MOBILES",
    GADGETS = "GADGETS",
    REFURBISH = "REFURBISH",
    SERVICEOFFER = "SERVICEOFFER"
}